var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.413 1050.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.823,23.019C90.8,22.632,80.3,19.035,70.281,15.1S50.331,6.8,39.574,4.718C32.656,3.377,24.742,3.187,19.169,6.937c-5.366,3.616-7.1,9.839-8.031,15.621-.7,4.349-1.114,8.925.809,13,1.333,2.827,3.7,5.2,5.338,7.92,5.7,9.421,1.672,21.039-4.5,30.238C9.887,78.029,6.524,82.149,4.29,86.739S1.02,96.6,2.975,101.282c1.94,4.649,6.559,8.133,11.562,10.587,10.164,4.984,22.137,6.41,33.82,7.217,25.854,1.788,51.845,1.014,77.767.239,9.594-.287,19.229-.579,28.666-2.078,5.241-.833,10.651-2.154,14.456-5.346a12.335,12.335,0,0,0,2.792-15.991C166.608,87.39,151.6,85.274,147.8,76.128c-2.088-5.033.058-10.638,3.092-15.307,6.512-10.013,17.425-18.8,18-30.245.394-7.863-4.853-15.734-12.966-19.455-8.5-3.913-20.3-3.418-26.565,3.037C122.9,20.809,111.553,23.36,101.823,23.019Z",
    transform: "translate(0.324 0.64)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.711,109.091,14.426,108.8,8.635,95.07l20.478-1.5L25.544,78.509l40.5-5.308L27.262,59.569l3.426-.823L93.055,69.033l-3.435,23.5-4.909,12.914Z",
    transform: "translate(1.439 9.791)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.365,96.73s3.576-.578,5.722,1.976c0,0-1.573,1.253-4.959-.482Z",
    transform: "translate(2.394 16.112)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.254,96.673s-2.282,2.839-1.158,6c0,0,1.859-.753,2.062-4.585Z",
    transform: "translate(2.131 16.112)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.287,92.8s1.43-2.653,7.152,1.06a3.207,3.207,0,0,1-3.29,1.639A3.883,3.883,0,0,1,12.287,92.8Z",
    transform: "translate(2.048 15.314)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.435,92.509s-2.968-.344-3.256,6.525A3.2,3.2,0,0,0,12.4,97.256,3.949,3.949,0,0,0,12.435,92.509Z",
    transform: "translate(1.53 15.418)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.489,88.175s1.669-4.676,7.724-1.35c0,0-1.383,4.29-7.1,2.941Z",
    transform: "translate(1.748 14.272)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.895,82.135s3.147-4.724,8.725-.344c0,0-1.955,4.435-8.249,2.025Z",
    transform: "translate(1.482 13.321)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.323,76.393s3.671-4.34,9.2,0c0,0-3.481,3.808-9.2,1.109Z",
    transform: "translate(1.387 12.411)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.832,70.878s3.719-4.531,9.011-.241c0,0-4.2,4-9.011,1.3Z",
    transform: "translate(1.305 11.465)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.118,66.127s3.917-5.833,8.868-1.88c0,0-4.2,5.014-8.868,2.989Z",
    transform: "translate(1.353 10.479)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.895,60.351s4.148-5.785,8.964-1.35c0,0-4.911,5.014-8.964,2.41Z",
    transform: "translate(1.482 9.554)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.11,55.325s4.911-5.437,9.2-3.271c0,0-5.117,5.775-9.41,4.714Z",
    transform: "translate(1.649 8.591)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.609,50.616s5.667-6.659,8.964-4.435c0,0-4.175,5.165-9.366,5.681Z",
    transform: "translate(1.868 7.621)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.77,44.888s4.96-5.437,8.584-4.087c0,0-4.244,5.64-9.25,5.785Z",
    transform: "translate(2.184 6.764)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.631,39.621s5.483-5.206,7.867-4.291c0,0-3.957,5.785-8.106,5.447Z",
    transform: "translate(2.565 5.87)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.477,34.941s4.72-6.22,7.3-5.738c0,0-2.862,5.546-7.3,6.37Z",
    transform: "translate(2.913 4.862)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.541,28.222s4.172-4.767,6.426-4.757c0,0-3.293,6.37-6.6,6.312Z",
    transform: "translate(3.228 3.911)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,24.585l4.031-9.931s.2,8.977-4.543,11.773Z",
    transform: "translate(3.381 2.442)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.133,15.06s.668-8.293.238-8.968c0,0,2.881,6.9-.266,12.632Z",
    transform: "translate(3.684 1.015)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.338,87.793S7.159,85.174,4.453,91.58c0,0,3.719,2.5,7.377-2.154Z",
    transform: "translate(0.742 14.544)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.868,81.649s-5.126-2.364-7.612,4.325c0,0,3.959,2.755,8.078-2.634Z",
    transform: "translate(0.376 13.541)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.433,76.734s-3.671-4.34-9.2,0c0,0,3.481,3.808,9.2,1.109Z",
    transform: "translate(0.04 12.467)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.011,70.878S5.292,66.346,0,70.637c0,0,4.2,4,9.011,1.3Z",
    transform: "translate(0 11.465)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,66.436S6.692,59.9,1.021,62.712c0,0,3.065,5.793,8.048,4.809Z",
    transform: "translate(0.17 10.335)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.368,60.517s-2.593-6.647-8.344-3.566c0,0,3.521,6.093,8.088,4.592Z",
    transform: "translate(0.337 9.356)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.382,55.947s-1.022-7.288-5.79-7.94c0,0,1.011,7.686,5.148,9.254Z",
    transform: "translate(0.932 8.001)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.275,51.228s-.4-8.781-4.341-9.087c0,0,.133,6.665,3.9,10.33Z",
    transform: "translate(1.322 7.023)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.731,45.233s-1.175-7.3-4.938-8.193c0,0,.467,7.071,4.565,9.986Z",
    transform: "translate(1.632 6.173)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.36,40.291s-.039-7.606-2.338-8.724c0,0-1.425,6.887,1.672,9.695Z",
    transform: "translate(2.282 5.261)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.027,35.32s-.322-7.832-2.7-8.936c0,0-.814,6.2,2.347,9.448Z",
    transform: "translate(2.538 4.397)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127,29.2s-.014-6.37-1.713-7.865c0,0-1.689,6.978.826,9.146Z",
    transform: "translate(2.976 3.556)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.881,24.412l-1.654-10.6S16.981,22.5,20.959,26.326Z",
    transform: "translate(3.099 2.301)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.425,15s-4.244-7.128-4.157-7.92c0,0,.451,7.47,5.79,11.191Z",
    transform: "translate(2.878 1.179)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.087,13.623S18.082,3.5,16.271,2.68a12.835,12.835,0,0,1,6.151,10.654Z",
    transform: "translate(2.712 0.446)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.391,31.831l-.274-.084C22.5,20.6,23.34,13.5,21.493,11.715l.2-.21C23.648,13.385,22.853,20.413,19.391,31.831Z",
    transform: "translate(3.186 1.917)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.432,55.137l-.405-.146c.359-1.021.746-2.057,1.151-3.078,3.528-8.891,6.532-17.162,8.458-23.511l.352-.172c-1.929,6.362-4.88,14.949-8.412,23.852C12.172,53.083,11.788,54.115,11.432,55.137Z",
    transform: "translate(1.838 4.705)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.551,112.771A56.436,56.436,0,0,1,11.2,95.825a63.312,63.312,0,0,1-3.69-19.417,74,74,0,0,1,4.4-25.944l.32.379c-6.614,18.864-3.986,35.029-.5,44.764A55.935,55.935,0,0,0,20.98,112.39Z",
    transform: "translate(1.247 8.411)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.194,92.519s-3.86,4.764-.8,11.965L65.577,118l-2.958.627L61.257,112.6l.911-7.6V100.84Z",
    transform: "translate(10.21 15.42)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.635,91l42.66-7.863,56.526,9.1-35.109,12.78Z",
    transform: "translate(1.439 13.857)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.635,91l42.66-7.863,56.526,9.1-35.109,12.78Z",
    transform: "translate(1.439 13.857)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.864,89.879s-3.99,7.643.608,14.7l63.261,13.86s-3.927-6.088.2-14.538Z",
    transform: "translate(1.21 14.98)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.864,89.879s-3.99,7.643.608,14.7l63.261,13.86s-3.927-6.088.2-14.538Z",
    transform: "translate(1.21 14.98)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,92.15s-2.28,5.592,0,9.211Z",
    transform: "translate(1.564 15.358)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.416,116.537,107.733,101.3s1.975.43.7,1.893S73.1,118,73.1,118L9.155,102.677Z",
    transform: "translate(1.526 16.883)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.416,116.537,107.733,101.3s1.975.43.7,1.893S73.1,118,73.1,118L9.155,102.677Z",
    transform: "translate(1.526 16.883)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.114,103.218s-3.406,4.132,0,10.33Z",
    transform: "translate(9.933 17.203)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.213,103.158l-15.276,5.153.054.163,15.276-5.153Z",
    transform: "translate(10.323 17.193)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.273,102.719,61.933,109.77l.061.161,18.341-7.051Z",
    transform: "translate(10.322 17.12)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07,102.7l-21.048,8.712.065.159,21.048-8.71Z",
    transform: "translate(10.337 17.116)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.089,102.058l-23.858,10.9.07.158,23.858-10.9Z",
    transform: "translate(10.372 17.01)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.629,102.061l-26.236,11.6.068.158,26.236-11.6Z",
    transform: "translate(10.399 17.01)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.187,101.235,62.731,114.971l.068.158,31.456-13.736Z",
    transform: "translate(10.455 16.872)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.219,91.511l29.97-6.37L70.447,88.67,45.888,96.676Z",
    transform: "translate(3.703 14.19)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.667,90.944s1.55.632.64,1.608-35.755,11.172-35.755,11.172Z",
    transform: "translate(10.592 15.157)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.685,78.326s-3.858,4.762-.793,11.966L80.07,103.806l-2.958.63L75.75,98.411l.925-7.6V86.646Z",
    transform: "translate(12.625 13.054)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.128,76.808l42.658-7.861,56.528,9.1L87.2,90.832Z",
    transform: "translate(3.855 11.491)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.352,75.685s-3.992,7.643.606,14.7l63.26,13.859s-3.925-6.093.21-14.539Z",
    transform: "translate(3.624 12.614)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.352,75.685s-3.992,7.643.606,14.7l63.26,13.859s-3.925-6.093.21-14.539l-20-4.378Z",
    transform: "translate(3.624 12.614)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.887,77.957s-2.278,5.59,0,9.211Z",
    transform: "translate(3.979 12.993)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.909,102.343l35.319-15.237s1.973.43.7,1.894S87.59,103.807,87.59,103.807L23.648,88.483Z",
    transform: "translate(3.941 14.518)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.909,102.343l35.319-15.237s1.973.43.7,1.894S87.59,103.807,87.59,103.807L23.648,88.483Z",
    transform: "translate(3.941 14.518)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.605,89.024s-3.406,4.132,0,10.33Z",
    transform: "translate(12.349 14.837)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.706,88.966,76.43,94.119l.054.163L91.76,89.13Z",
    transform: "translate(12.738 14.828)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.767,88.526l-18.34,7.051.06.161,18.341-7.051Z",
    transform: "translate(12.738 14.754)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.562,88.5,76.514,97.213l.065.159,21.048-8.711Z",
    transform: "translate(12.752 14.75)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.585,87.864,76.727,98.76l.07.157,23.858-10.9Z",
    transform: "translate(12.788 14.644)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.122,87.865,76.886,99.46l.068.158L103.19,88.023Z",
    transform: "translate(12.814 14.644)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.682,87.038,77.226,100.775l.068.158L108.749,87.2Z",
    transform: "translate(12.871 14.506)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.713,77.317l29.97-6.37,18.258,3.529L60.382,82.482Z",
    transform: "translate(6.119 11.824)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16,76.751s1.548.632.641,1.606S78.051,89.529,78.051,89.529Z",
    transform: "translate(13.009 12.792)",
    fill: "#3a3768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.057,62.088s-3.861,8.552-.8,15.753L81.44,87.569l-2.951.632-1.362-6.026.911-7.6V70.409Z",
    transform: "translate(12.855 10.348)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,60.573l42.66-7.863,56.527,9.1L88.581,74.594Z",
    transform: "translate(4.084 8.785)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.735,59.448s-4,7.642.6,14.7L88.6,88.009s-3.927-6.093.208-14.538Z",
    transform: "translate(3.854 9.908)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.735,59.448s-4,7.642.6,14.7L88.6,88.009s-3.927-6.093.208-14.538Z",
    transform: "translate(3.854 9.908)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.265,61.719s-2.28,5.592,0,9.211Z",
    transform: "translate(4.209 10.286)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.286,85.909,123.6,74.46s1.975.43.7,1.894S88.967,87.372,88.967,87.372L25.025,72.049Z",
    transform: "translate(4.171 12.008)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.286,85.909,123.6,74.46s1.975.43.7,1.894S88.967,87.372,88.967,87.372L25.025,72.049Z",
    transform: "translate(4.171 12.008)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.984,72.787s-3.406,4.132,0,10.33Z",
    transform: "translate(12.579 12.131)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.085,72.729,77.809,77.881l.054.163,15.276-5.153Z",
    transform: "translate(12.968 12.121)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.145,72.289,77.8,79.34l.061.161,18.34-7.051Z",
    transform: "translate(12.968 12.048)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.938,72.266,77.89,80.977l.065.159L99,72.426Z",
    transform: "translate(12.982 12.044)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.962,71.626,78.1,82.523l.07.157,23.858-10.9Z",
    transform: "translate(13.017 11.938)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,71.629,78.265,83.224l.068.158,26.236-11.595Z",
    transform: "translate(13.044 11.938)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.061,70.8,78.6,84.54l.068.158,31.456-13.736Z",
    transform: "translate(13.101 11.8)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.089,61.08l29.97-6.37,18.258,3.529L61.758,66.245Z",
    transform: "translate(6.348 9.118)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.536,60.513s1.55.632.641,1.608S79.427,73.294,79.427,73.294Z",
    transform: "translate(13.238 10.085)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.134,15.718s-6.471-.394-5.715,4.2a1.125,1.125,0,0,0,.576,1.179s.012-.344.664-.226a2.865,2.865,0,0,0,.7.034,1.459,1.459,0,0,0,.86-.358s1.82-.761,2.529-3.77c0,0,.524-.656.511-.825l-1.1.472a2.007,2.007,0,0,1,.08,1.46s-.036-1.431-.247-1.4c-.043,0-.567.277-.567.277a3.3,3.3,0,0,1,.157,2.4s.184-1.711-.358-2.3l-.77.455a3.468,3.468,0,0,1,.242,2.6,4.93,4.93,0,0,0-.4-2.495l-.7.551a3.387,3.387,0,0,1,.276,2.385s-.056-2.09-.426-2.249a4.233,4.233,0,0,0-.7.768s.484,1.033.182,1.568c0,0-.182-1.393-.341-1.4a4.659,4.659,0,0,0-.671,1.549,3.375,3.375,0,0,1,.523-1.642,1.816,1.816,0,0,0-.93.487s.094-.653,1.081-.709a4.219,4.219,0,0,1,.637-.742,3.946,3.946,0,0,0-1.577.182,1.774,1.774,0,0,1,1.756-.344l.681-.568a5.812,5.812,0,0,0-1.839.019,2.221,2.221,0,0,1,2.025-.148l.751-.453a6.754,6.754,0,0,0-1.757-.153,2.67,2.67,0,0,1,1.977.031l.535-.243s-.805-.16-1.042-.186-.249-.091-.249-.091a2.784,2.784,0,0,1,1.516.172A6.716,6.716,0,0,0,46.134,15.718Z",
    transform: "translate(6.726 2.618)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.163,31.889s-6.471-.394-5.715,4.2a1.125,1.125,0,0,0,.576,1.179s.012-.344.664-.226a2.965,2.965,0,0,0,.7.035,1.454,1.454,0,0,0,.852-.358s1.822-.761,2.528-3.77c0,0,.525-.656.511-.825l-1.093.472a2.006,2.006,0,0,1,.08,1.46s-.036-1.431-.245-1.4c-.043,0-.569.277-.569.277a3.3,3.3,0,0,1,.159,2.4s.184-1.711-.359-2.3l-.77.454a3.469,3.469,0,0,1,.243,2.6,4.935,4.935,0,0,0-.4-2.495l-.7.551a3.392,3.392,0,0,1,.274,2.385s-.057-2.09-.426-2.249a4.285,4.285,0,0,0-.7.768s.483,1.033.184,1.568c0,0-.184-1.393-.341-1.4a4.659,4.659,0,0,0-.671,1.55,3.365,3.365,0,0,1,.524-1.643,1.823,1.823,0,0,0-.931.487s.094-.653,1.081-.709a4.29,4.29,0,0,1,.636-.744,3.959,3.959,0,0,0-1.576.184A1.773,1.773,0,0,1,120.436,34l.681-.568a5.818,5.818,0,0,0-1.84.019A2.22,2.22,0,0,1,121.3,33.3l.749-.453a6.748,6.748,0,0,0-1.757-.153,2.668,2.668,0,0,1,1.976.031l.537-.243s-.807-.16-1.044-.186-.249-.091-.249-.091a2.763,2.763,0,0,1,1.516.172A6.864,6.864,0,0,0,124.163,31.889Z",
    transform: "translate(19.731 5.313)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.671,40.565s-2.82-5.91-6.409-3a1.116,1.116,0,0,0-.737,1.083s.3-.157.511.477a3.059,3.059,0,0,0,.313.637,1.473,1.473,0,0,0,.731.585s1.544,1.236,4.489.392c0,0,.823.143.957.043l-.94-.735a1.976,1.976,0,0,1-1.223.782s1.219-.728,1.088-.9c-.027-.034-.511-.367-.511-.367a3.234,3.234,0,0,1-1.994,1.308s1.567-.671,1.808-1.438l-.766-.458a3.4,3.4,0,0,1-2.132,1.484s1.614-.759,1.957-1.572L52,38.549s-.877,1.312-1.926,1.407c0,0,1.778-1.069,1.734-1.474a4.274,4.274,0,0,0-1.006-.246s-.651.928-1.263.928c0,0,1.112-.842,1.044-.978a4.446,4.446,0,0,0-1.669.172,3.285,3.285,0,0,1,1.674-.344,1.833,1.833,0,0,0-.875-.584s.61-.234,1.139.608a4.16,4.16,0,0,1,.952.2,4.042,4.042,0,0,0-.926-1.3s.787.16,1.146,1.377l.826.331a5.762,5.762,0,0,0-.913-1.613s.776.291,1.115,1.722l.756.441a6.851,6.851,0,0,0-.724-1.625,2.732,2.732,0,0,1,.937,1.76l.472.355s-.255-.79-.341-1.011-.043-.265-.043-.265a2.842,2.842,0,0,1,.593,1.42A6.359,6.359,0,0,0,55.671,40.565Z",
    transform: "translate(8.087 6.127)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.687,25.274s-2.819-5.911-6.41-3a1.117,1.117,0,0,0-.737,1.083s.3-.155.511.477a3.014,3.014,0,0,0,.315.639,1.463,1.463,0,0,0,.729.584s1.546,1.236,4.488.394c0,0,.822.141.959.041l-.935-.737a1.976,1.976,0,0,1-1.221.783s1.218-.73,1.086-.9c-.027-.034-.511-.367-.511-.367a3.229,3.229,0,0,1-1.994,1.308s1.569-.671,1.811-1.436L109,23.693a3.405,3.405,0,0,1-2.133,1.484s1.615-.761,1.959-1.574l-.815-.344s-.877,1.314-1.925,1.407c0,0,1.777-1.069,1.732-1.472a4.178,4.178,0,0,0-1-.246s-.651.926-1.266.926c0,0,1.114-.842,1.045-.978a4.456,4.456,0,0,0-1.671.172,3.286,3.286,0,0,1,1.674-.344,1.824,1.824,0,0,0-.873-.584s.609-.234,1.139.608a4.175,4.175,0,0,1,.952.2,4.028,4.028,0,0,0-.929-1.3s.787.162,1.147,1.386l.827.331a5.762,5.762,0,0,0-.912-1.615s.776.291,1.113,1.722l.758.441a6.9,6.9,0,0,0-.726-1.625,2.726,2.726,0,0,1,.937,1.76l.471.355s-.253-.79-.341-1.011-.042-.263-.042-.263a2.844,2.844,0,0,1,.59,1.42A6.564,6.564,0,0,0,111.687,25.274Z",
    transform: "translate(17.423 3.578)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.407,50.333s-2.818-5.912-6.414-3a1.117,1.117,0,0,0-.737,1.083s.3-.155.511.477a3.008,3.008,0,0,0,.313.639,1.468,1.468,0,0,0,.729.584s1.546,1.238,4.49.394c0,0,.821.143.957.041l-.939-.735a1.976,1.976,0,0,1-1.223.783s1.217-.73,1.086-.9c-.028-.035-.511-.367-.511-.367a3.236,3.236,0,0,1-1.994,1.31s1.568-.673,1.809-1.438l-.768-.458a3.4,3.4,0,0,1-2.132,1.484s1.614-.761,1.958-1.574l-.815-.344s-.877,1.312-1.924,1.407c0,0,1.777-1.069,1.734-1.474A4.2,4.2,0,0,0,114.53,48s-.651.926-1.266.926c0,0,1.114-.842,1.046-.978a4.458,4.458,0,0,0-1.671.172,3.291,3.291,0,0,1,1.675-.344,1.819,1.819,0,0,0-.875-.584s.609-.236,1.139.608a4.161,4.161,0,0,1,.952.2,4.065,4.065,0,0,0-.926-1.3s.786.162,1.146,1.386l.826.331a5.737,5.737,0,0,0-.912-1.613s.777.289,1.114,1.722l.757.439a6.9,6.9,0,0,0-.726-1.625,2.729,2.729,0,0,1,.939,1.761l.471.344s-.255-.79-.341-1.011-.043-.263-.043-.263a2.832,2.832,0,0,1,.591,1.42A6.92,6.92,0,0,0,119.407,50.333Z",
    transform: "translate(18.709 7.754)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.035,115.846c2.162,0,3.915-.2,3.915-.442s-1.753-.442-3.915-.442-3.915.2-3.915.442S27.873,115.846,30.035,115.846Z",
    transform: "translate(4.353 19.16)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.038,109.4c2.162,0,3.915-.2,3.915-.442s-1.753-.442-3.915-.442-3.915.2-3.915.442S5.876,109.4,8.038,109.4Z",
    transform: "translate(0.687 18.086)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,120.127c2.162,0,3.915-.2,3.915-.442s-1.753-.442-3.915-.442-3.915.2-3.915.442S44.64,120.127,46.8,120.127Z",
    transform: "translate(7.148 19.874)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.729,110.8c2.162,0,3.915-.2,3.915-.442s-1.753-.442-3.915-.442-3.915.2-3.915.442S130.568,110.8,132.729,110.8Z",
    transform: "translate(21.469 18.32)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8,108.962c2.162,0,3.915-.2,3.915-.442s-1.753-.442-3.915-.442-3.914.2-3.914.442S102.642,108.962,104.8,108.962Z",
    transform: "translate(16.815 18.013)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.844,118.041c2.557,0,4.63-.359,4.63-.8s-2.073-.8-4.63-.8-4.63.36-4.63.8S84.287,118.041,86.844,118.041Z",
    transform: "translate(13.702 19.405)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.535,110.195s-6.447,3.368-3.116,7.335a1.247,1.247,0,0,0,1.219.8s-.18-.334.511-.6a3.3,3.3,0,0,0,.7-.373,1.657,1.657,0,0,0,.623-.842s1.318-1.784.3-5.084a3.3,3.3,0,0,0,.017-1.084L88,111.432a2.218,2.218,0,0,1,.9,1.357s-.851-1.356-1.022-1.205c-.038.03-.388.594-.388.594A3.643,3.643,0,0,1,89,114.389s-.79-1.751-1.643-2l-.489.882a3.824,3.824,0,0,1,1.7,2.363s-.891-1.8-1.8-2.163l-.359.931s1.478.951,1.614,2.132c0,0-1.236-1.974-1.681-1.912a4.819,4.819,0,0,0-.242,1.145s1.044.706,1.062,1.4c0,0-.964-1.231-1.112-1.15a5.245,5.245,0,0,0,.235,1.882,3.747,3.747,0,0,1-.427-1.882,2.073,2.073,0,0,0-.618,1.006s-.278-.68.637-1.307a4.814,4.814,0,0,1,.192-1.081,4.486,4.486,0,0,0-1.41,1.089s.155-.894,1.5-1.338l.341-.943a6.319,6.319,0,0,0-1.756,1.08s.3-.887,1.861-1.311l.463-.861a7.76,7.76,0,0,0-1.774.861,3.013,3.013,0,0,1,1.917-1.114l.376-.542s-.865.311-1.107.423-.289.057-.289.057a3.111,3.111,0,0,1,1.551-.713A7.685,7.685,0,0,0,88.535,110.195Z",
    transform: "translate(14.077 18.366)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,64.957c-1.113-3.059-7.243-3.347-9.9-2.567a78.763,78.763,0,0,1-8,1.5l-.138-.133c.276-.083.283-.286.249-.587a9.29,9.29,0,0,1,.017-1.191,2.88,2.88,0,0,0,2.466-.56c1.533-.689,1.12-3.636,1.413-4.442a51.636,51.636,0,0,0,.562-5.923h.022l.012-.594c.015-.257.022-.406.022-.406a41.163,41.163,0,0,1,.443-5.2,46.017,46.017,0,0,0,.528-5.509v-.084l-.022-.375c.015-.274.022-.578.02-.9,0-1.472-.152-3.326-.17-3.626V34.2c.012-.628-.066-3.776-2.714-4.965-.976-.441-2.149-.966-3.285-1.477-.293-2.557-.962-5.1-.9-7.675,0-.387.034-.775.072-1.16,0,.112-.012.226-.014.344v.751c.1-3.221,1.3-6.46,1.192-9.612-.01.308-.032.618-.061.928a10.115,10.115,0,0,0-.327-3.166,1.88,1.88,0,0,0-.535-.981,2.188,2.188,0,0,0-.933-.374,18.579,18.579,0,0,0-2.45-.461,3.841,3.841,0,0,0-.552-1.083C87.882,2.868,85.325.616,82.3.1a4.819,4.819,0,0,0-4.295,1.054,3.231,3.231,0,0,0-.3.31c-.555.67-.794,1.55-1.362,2.218-.037.045-.08.086-.121.129-1.114,1.007-2.849,1.217-4.087,2.121a4.915,4.915,0,0,0-.611.539,10.453,10.453,0,0,0-1.335,1.641,6.833,6.833,0,0,0-1.306,2.562c-.356,1.894.919,3.69,1.156,5.6.528,4.265-4.14,8.049-3.256,12.257a5.631,5.631,0,0,0,1.5,2.725c-1.82,1.667-3.37,3.283-3.37,3.283v.1h-.288l.029.344h-.029l.158,1.868-.158,2.72v.256h.01a43.963,43.963,0,0,0,.511,5.337,41.084,41.084,0,0,1,.441,5.2s.324,6.117.62,6.926-.124,3.748,1.413,4.442a3.217,3.217,0,0,0,1.544.647c-.078.644-.029,1.11.225,1.257a.736.736,0,0,0,.358.1,3.859,3.859,0,0,0-.278.491,7.145,7.145,0,0,1-1.785-.425c-1.652-.689-7.133-2.238-8.725-1.148s-5.424,2.078-3.654,6.465,2.593,4.5,2.593,4.5a6.335,6.335,0,0,1,1.415,1.438c.531.808,5.481,2.655,6.719,2.655a12,12,0,0,1,1.575.079s-1.344,1.191-1.165,1.883a57.773,57.773,0,0,1-.409,6.233s1.362,1.388,1.945-.432L68,85.5c.109.15.7.826,1.807-.028a10.112,10.112,0,0,1,1.441-.923l5.367-.768a15.015,15.015,0,0,1,1.681-.012,3.489,3.489,0,0,0,2.214-.833c1.112.427,2.362.894,2.956,1.064,1.206.344,6.747,1.847,8.042,1.377a1.8,1.8,0,0,0,.7-.5l1.236.04-.579.117s1.127.019,2.66.04l-.065.038,1.922-.017c2.813.026,5.974.034,6.389-.06a44.375,44.375,0,0,1,5.027,0h.278s3.714-.749,2.18-4.559c-1.178-2.927-4.8-3.777-6.407-4.011.453-.091.843-.162,1.1-.2a8.673,8.673,0,0,0,3.479-1.558c.177-.353,2-1.377,2.477-1.961A11.079,11.079,0,0,0,112.6,64.957ZM81.842,73.519l-.182.06-.123.041-.235.234c-.187-.127-.388-.262-.6-.4C81.074,73.478,81.454,73.5,81.842,73.519Z",
    transform: "translate(9.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.293,50.49s2.605,6.887,4.087,6.2,1.08-3.616,1.362-4.418.6-6.887.6-6.887a42.071,42.071,0,0,1,.426-5.175,47.948,47.948,0,0,0,.511-5.473V34.65l-.281-4.993-1.59-.4-3.688,1.377L88.2,33.583,88,34.735l-.085.491Z",
    transform: "translate(14.549 4.876)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.028,46.468a18.288,18.288,0,0,0,3.235,2.238c.749.181,1.209,1.785,1.209,1.785",
    transform: "translate(14.671 7.744)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.827,50.748s-2.605,6.887-4.087,6.2-1.08-3.616-1.362-4.418-.6-6.887-.6-6.887a42.072,42.072,0,0,0-.426-5.175,47.946,47.946,0,0,1-.511-5.473v-.084l.283-4.993,1.59-.4,3.688,1.377.511,2.949.2,1.152.085.491Z",
    transform: "translate(10.641 4.919)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2,16.125H79.386V25.29H85.2Z",
    transform: "translate(13.231 2.687)",
    fill: "#3e373a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2,16.125H79.386V25.29H85.2Z",
    transform: "translate(13.231 2.687)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.155,53.672s-1.987,2.209-1.25,2.61,5.507,7.92,5.507,7.92,15.666,1.951,18.621-.976,2.895-8.156,2.895-8.156-2.374.517-2.633.236-1.681-1.634-1.681-1.634S70.517,52.439,69.155,53.672Z",
    transform: "translate(11.29 8.854)",
    fill: "#4b4b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.155,53.672s-1.987,2.209-1.25,2.61,5.507,7.92,5.507,7.92,15.666,1.951,18.621-.976,2.895-8.156,2.895-8.156-2.374.517-2.633.236-1.681-1.634-1.681-1.634S70.517,52.439,69.155,53.672Z",
    transform: "translate(11.29 8.854)",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.967,31.926l-5.109,4.132-1.544.114-.567.041-9.524.706-9.876-.73-1.47-.108L68,35.942l-3.917-3.788a67.4,67.4,0,0,1,5.2-5.029,10.661,10.661,0,0,1,2.52-1.7l.112-.04A2.8,2.8,0,0,0,73,24.622c1.917-2,3.69-6.932,3.69-6.932s8.458-4.418,7.436,1.377,3.8,4.363,3.8,4.363l1.59.733.628.291,1.6.742,3.615,1.677C98.2,28.195,97.967,31.926,97.967,31.926Z",
    transform: "translate(10.681 2.68)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.521,23.7a7.691,7.691,0,1,0-7.607-7.691A7.649,7.649,0,0,0,79.521,23.7Z",
    transform: "translate(11.986 1.387)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.02,36.077H63.846v-.084L64.128,31a67.409,67.409,0,0,1,5.2-5.029l21.456-.861,1-1.064L95.4,25.722c2.839,1.319,2.61,5.05,2.61,5.05S98.4,35.1,98.02,36.077Z",
    transform: "translate(10.641 4.007)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.02,35.929H63.846v-.084l.283-4.993a67.409,67.409,0,0,1,5.2-5.029l21.456-.861,1-1.064L95.4,25.575c2.839,1.319,2.61,5.05,2.61,5.05S98.4,34.948,98.02,35.929Z",
    transform: "translate(10.641 3.983)",
    fill: "#e7c7ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.043,22.424s5.391,6.945,12.572-.143.8,15.81.8,15.81l-15.5,1.859Z",
    transform: "translate(11.986 3.487)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.043,22.72s5.391,6.945,12.572-.143.8,15.81.8,15.81l-15.5,1.859Z",
    transform: "translate(11.986 3.536)",
    fill: "#e7c7ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.558,23.59l.57,8.8.611,2.927.467,2.238s1.192,17.217.851,18.078.17,1.55.242,2.007-.072,1.608-.015,2.125,0,.745-1.3.561-3.123-.5-3.123-.5-4.6.344-6.186-.229a17.964,17.964,0,0,0-4.6-.575s-4.541.115-6.016-.057-2.272,1.837-3.235,1.262,1.134-6.139,1.815-7.747-.908-5.682-.908-5.682l2.043-11.461.455-2.6V24.563l.112-.04a2.8,2.8,0,0,0,1.08-.761l.511,8.219,16.007.575V23.306",
    transform: "translate(11.262 3.884)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.558,23.295l.57,8.8.611,2.927.467,2.238s1.192,17.217.851,18.078.17,1.55.242,2.007-.072,1.608-.015,2.125,0,.745-1.3.561-3.123-.5-3.123-.5-4.6.344-6.186-.229a17.959,17.959,0,0,0-4.6-.575s-4.541.115-6.016-.057-2.272,1.837-3.235,1.262,1.134-6.14,1.815-7.748-.908-5.682-.908-5.682l2.043-11.461.455-2.6V24.268l.112-.04a2.8,2.8,0,0,0,1.08-.761l.511,8.219,16.007.575V23.011",
    transform: "translate(11.262 3.835)",
    fill: "#e7c7ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,8.679a1.9,1.9,0,0,0-.511-.974,2.079,2.079,0,0,0-.9-.372,17.588,17.588,0,0,0-2.364-.458A3.844,3.844,0,0,0,87.455,5.8c-1.669-2.383-4.138-4.63-7.043-5.137a4.435,4.435,0,0,0-4.257,1.185c-.535.666-.765,1.55-1.3,2.2-1.04,1.271-2.919,1.427-4.23,2.41a7.9,7.9,0,0,0-1.7,1.992A6.861,6.861,0,0,0,67.66,11c-.341,1.878.887,3.669,1.114,5.564.511,4.241-3.985,8-3.135,12.186.5,2.44,2.725,4.158,5.03,5.029a3.488,3.488,0,0,1,2.12,1.4c.17.344.2.742.359,1.09.538,1.16,2.307,1.205,3.258.36a5.163,5.163,0,0,0,1.362-3.488c.456-5.571-1.75-11.076-1.493-16.661.077-1.689.547-3.605,2.043-4.37,2.014-1.033,4.438.689,6.655.36a13.486,13.486,0,0,1,.637,8.145A22.461,22.461,0,0,0,84.6,25.08c-.066,2.333,1.178,4.464,2.254,6.527a3.5,3.5,0,0,1,.455,1.258,3.062,3.062,0,0,1-.244,1.317c-.608,1.654-1.657,3.19-1.776,4.951a.807.807,0,0,0,.128.589.728.728,0,0,0,.439.2c1.839.318,3.43-1.329,4.327-2.984A14.1,14.1,0,0,0,91.893,31c.186-3.505-1.057-6.954-.981-10.463C91,16.544,92.783,12.527,91.74,8.679Z",
    transform: "translate(10.922 0.094)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.885,8.532a1.9,1.9,0,0,0-.511-.974,2.079,2.079,0,0,0-.9-.372,17.588,17.588,0,0,0-2.364-.458A3.844,3.844,0,0,0,87.6,5.655c-1.669-2.383-4.138-4.63-7.043-5.137A4.435,4.435,0,0,0,76.3,1.7c-.535.666-.765,1.55-1.3,2.2-1.04,1.271-2.919,1.427-4.23,2.41a7.9,7.9,0,0,0-1.7,1.992,6.861,6.861,0,0,0-1.258,2.546c-.341,1.878.887,3.669,1.114,5.564.511,4.24-3.985,8-3.135,12.186.5,2.44,2.725,4.158,5.03,5.029a3.487,3.487,0,0,1,2.12,1.4c.17.344.2.742.359,1.09.538,1.16,2.307,1.205,3.258.36A5.162,5.162,0,0,0,77.913,33c.456-5.571-1.75-11.076-1.493-16.661.077-1.689.547-3.605,2.043-4.37,2.014-1.033,4.438.689,6.655.36a13.486,13.486,0,0,1,.637,8.145,22.455,22.455,0,0,0-1.006,4.459C84.682,27.265,85.927,29.4,87,31.459a3.5,3.5,0,0,1,.455,1.259,3.062,3.062,0,0,1-.244,1.317c-.608,1.655-1.657,3.19-1.776,4.952a.807.807,0,0,0,.128.589.728.728,0,0,0,.439.2c1.839.319,3.43-1.329,4.327-2.984a14.1,14.1,0,0,0,1.706-5.943c.186-3.505-1.057-6.954-.981-10.463C91.146,16.4,92.929,12.38,91.885,8.532Z",
    transform: "translate(10.946 0.07)",
    fill: "#3e373a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.917,73.406l6.755.219L90.7,68.559l-5.175.5Z",
    transform: "translate(14.153 11.426)",
    fill: "#c3c7d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.341,63.948c-.454.573-2.213,1.606-2.383,1.951a8.346,8.346,0,0,1-3.349,1.549A27.648,27.648,0,0,0,96.5,68.768a49.378,49.378,0,0,1-6.4,1.713,18.015,18.015,0,0,1-1.94.353c-1.022.057-12.2-3.788-12.2-3.788l2.156-2.238.119-.041c.61-.208,3.426-1.171,4.989-1.629a11.481,11.481,0,0,0,3.8-2.639s3.007-1.033,3.406-1.148-1.022-4.017-1.022-4.017a91.874,91.874,0,0,0,9.081-1.692c2.554-.776,8.458-.489,9.536,2.553A11.318,11.318,0,0,1,107.341,63.948Z",
    transform: "translate(12.659 8.879)",
    fill: "#4b4b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.422,71.6a3.971,3.971,0,0,1-2.61,1.264c-1.306-.114-5.873.344-5.873.344a9.134,9.134,0,0,0-2.3,1.348c-1.068.85-1.635.172-1.74.028l-.019-.028c-.569,1.809-1.873.43-1.873.43a58.9,58.9,0,0,0,.393-6.2c-.174-.689,1.122-1.871,1.122-1.871l1.533-.394,3.882-1.005L77.5,67.473Z",
    transform: "translate(10.834 10.92)",
    fill: "#e7c7ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.047,66.384,66.9,74.445l-.019-.028c-.569,1.81-1.873.43-1.873.43a58.9,58.9,0,0,0,.393-6.2c-.174-.689,1.122-1.871,1.122-1.871Z",
    transform: "translate(10.834 11.064)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,46.73a9.2,9.2,0,0,0,5.619,0Z",
    transform: "translate(12.417 7.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,48.4a2.46,2.46,0,0,0,2.214,0Z",
    transform: "translate(13.883 8.067)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,49.726s2.1.284,2.5-.289Z",
    transform: "translate(13.883 8.239)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.715,52.609s3.944-.516,4.923-1.205Z",
    transform: "translate(13.786 8.567)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,51.4a9.292,9.292,0,0,0,3.86,1.205Z",
    transform: "translate(12.067 8.567)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,68.84a17.985,17.985,0,0,1-1.94.353c-1.022.057-12.2-3.788-12.2-3.788l2.156-2.238.119-.041c.341.243.62.451.819.61.938.747,1.844-.229,2.185-.229a27.587,27.587,0,0,1,3.292,2.467s2.725.632,3.179,1.205,2.043.46,2.326.861A1.553,1.553,0,0,1,90.1,68.84Z",
    transform: "translate(12.659 10.521)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.478,55.532a12.213,12.213,0,0,1-4.344-.516c-1.589-.677-6.868-2.238-8.4-1.141s-5.223,2.066-3.52,6.429,2.5,4.476,2.5,4.476a6.184,6.184,0,0,1,1.362,1.429c.511.8,5.279,2.639,6.471,2.639a9.818,9.818,0,0,1,6.243,2.066,12.743,12.743,0,0,0,5.619,2.3s3.746,1.549,4.913,1.894,6.5,1.835,7.746,1.377,2.043-3.33,2.043-3.33.567-2.583.283-2.984-1.873-.288-2.326-.861S87.887,68.1,87.887,68.1A27.478,27.478,0,0,0,84.6,65.633c-.341,0-1.247.975-2.185.229a49.76,49.76,0,0,0-5.877-3.788C74.385,60.926,72.478,55.532,72.478,55.532Z",
    transform: "translate(9.296 8.916)",
    fill: "#4b4b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.345,56.677a3.227,3.227,0,0,1,2.791.745,49.229,49.229,0,0,0,5.946,3.454",
    transform: "translate(10.891 9.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.568,56.606s-6.074.93-7.208,2.192Z",
    transform: "translate(14.727 9.434)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.753,74.13h-.267a45.3,45.3,0,0,0-4.841,0c-.737.172-10.5,0-10.5,0l1.909-.4s-.708-2.51-.259-2.719c0,0-2.554-1.7-.628-2.849a5.916,5.916,0,0,1,4-.665L97,65.841l.928-.318s5.449.288,6.924,4.075S102.753,74.13,102.753,74.13Z",
    transform: "translate(14.524 10.92)",
    fill: "#e7c7ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.344,74.129h-.267c1.586-1.322,5.172-5.348-5.485-8.281l.928-.318s5.449.287,6.924,4.075S101.344,74.129,101.344,74.129Z",
    transform: "translate(15.932 10.921)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.978,69.162a.3.3,0,1,0-.3-.3A.3.3,0,0,0,91.978,69.162Z",
    transform: "translate(15.28 11.426)",
    fill: "#4b4b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.493,69.588a.3.3,0,1,0-.3-.3A.3.3,0,0,0,90.493,69.588Z",
    transform: "translate(15.033 11.498)",
    fill: "#4b4b5b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.67 10.827)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.605,15.56a13.486,13.486,0,0,0-.977-5.533c-2.214.334-4.638-1.393-6.655-.36-1.492.764-1.96,2.681-2.043,4.37-.02.446-.024.892-.015,1.338,0-.158,0-.319.015-.477.078-1.689.547-3.605,2.043-4.37,2.016-1.033,4.438.689,6.655.36A13.444,13.444,0,0,1,84.605,15.56Z",
    transform: "translate(-64.185 -9.272)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.687,15.2a5.8,5.8,0,0,0-.022-1.126c-.18-1.515-1-2.963-1.148-4.44-.191,1.782.931,3.493,1.148,5.3A1.086,1.086,0,0,1,68.687,15.2Z",
    transform: "translate(-65.42 -9.223)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.955,28.367a5.1,5.1,0,0,1-1.362,3.49c-.959.847-2.725.8-3.258-.36-.17-.344-.2-.746-.361-1.09-.378-.789-1.308-1.1-2.12-1.4-2.307-.873-4.533-2.583-5.028-5.029a5.329,5.329,0,0,1-.09-.672,5.486,5.486,0,0,0,.09,1.532c.5,2.44,2.725,4.156,5.028,5.029.812.308,1.742.615,2.12,1.4.17.344.2.742.361,1.09.536,1.16,2.306,1.205,3.258.36a5.164,5.164,0,0,0,1.362-3.49,19.9,19.9,0,0,0,.053-2.021C78.007,27.6,77.985,27.983,77.955,28.367Z",
    transform: "translate(-65.717 -6.944)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48,18.092v.745c.1-3.2,1.257-6.422,1.143-9.557C88.535,12.18,87.545,15.145,87.48,18.092Z",
    transform: "translate(-62.089 -9.281)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,29.053a2.239,2.239,0,0,0,.039-.621,3.463,3.463,0,0,0-.455-1.259c-.984-1.894-2.106-3.833-2.239-5.935,0,.089-.012.172-.014.269-.068,2.331,1.177,4.464,2.253,6.527A4.156,4.156,0,0,1,84.73,29.053Z",
    transform: "translate(-62.993 -7.288)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.266,25.851a14.123,14.123,0,0,1-1.718,5.943c-.9,1.655-2.488,3.3-4.329,2.984a.72.72,0,0,1-.439-.2.432.432,0,0,1-.08-.134c-.02.134-.037.27-.048.408a.8.8,0,0,0,.128.587.719.719,0,0,0,.439.2c1.841.318,3.43-1.329,4.329-2.984a14.123,14.123,0,0,0,1.718-5.943c.02-.4.022-.8.01-1.205C89.273,25.622,89.273,25.735,89.266,25.851Z",
    transform: "translate(-62.896 -6.577)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.557,70.543a5.983,5.983,0,0,0,7.152-2.217",
    transform: "translate(14.76 11.388)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.283,73.116a8.324,8.324,0,0,1,8-.076",
    transform: "translate(14.881 12.011)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.089,72.768s1.478-3.371,5.425-.8",
    transform: "translate(11.515 11.833)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.981,30.266,68,27.511s11.687-.775,12.17,3.242c0,0,4.143-4.762,12.856-3.7l3.687,2.968-10.19,4.521-9.9,3.473-7.293-3.3Z",
    transform: "translate(10.83 4.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.981,30.413,68,27.659s11.687-.775,12.17,3.242c0,0,4.143-4.762,12.856-3.7l3.687,2.968-10.19,4.521-9.9,3.473-7.293-3.3Z",
    transform: "translate(10.83 4.507)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.838,30.227l1.333,16.127,14.134.718-.613-16.058-.012-.27Z",
    transform: "translate(10.64 5.038)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.838,29.932l1.333,16.127,14.134.718-.613-16.058-.012-.27Z",
    transform: "translate(10.64 4.989)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.813,29.932l-14.58,2.211v16.2l14.248-2.081Z",
    transform: "translate(13.372 4.989)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.813,29.637l-14.58,2.211v16.2l14.248-2.082Z",
    transform: "translate(13.372 4.939)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.909,33.025l-7.876.885.172,2.713,7.7-.851Z",
    transform: "translate(13.839 5.504)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.687,53.209l.8,2.181a2.659,2.659,0,0,0,2.5.516,12.677,12.677,0,0,0,3.009-1.276A11.6,11.6,0,0,0,73.357,51.6s.8-2.755,1.589-3.443,2.895-10.177,0-9.249-5.108,9.536-5.108,9.536a2.016,2.016,0,0,1-1.248.689c-.737.058-2.214-.115-2.5.516S64.836,51.947,65.687,53.209Z",
    transform: "translate(10.891 6.474)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.846,31.979A4.865,4.865,0,0,1,76.57,30.9l.615,16.056a4.31,4.31,0,0,0,3.661,1.222Z",
    transform: "translate(12.762 5.15)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.846,31.684a4.865,4.865,0,0,1-4.276-1.078l.615,16.056a4.309,4.309,0,0,0,3.661,1.222Z",
    transform: "translate(12.762 5.101)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.846,31.684a4.865,4.865,0,0,1-4.276-1.078l.615,16.056a4.309,4.309,0,0,0,3.661,1.222Z",
    transform: "translate(12.762 5.101)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.525,30.208S86.456,28.374,88,28.633Z",
    transform: "translate(13.421 4.768)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,29.444s-5.749-1.377-6.709-.987Z",
    transform: "translate(11.515 4.731)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.731,30.313s3.966-1.47,5.4-.771Z",
    transform: "translate(13.955 4.892)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.019,62.221a13.015,13.015,0,0,1,1.955-1.228A31.808,31.808,0,0,0,86.869,59.2",
    transform: "translate(13.67 9.867)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.724,46.73a18.356,18.356,0,0,1-3.235,2.238c-.748.181-1.209,1.785-1.209,1.785",
    transform: "translate(10.88 7.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.011,52.946l-.794,2.186a2.661,2.661,0,0,1-2.5.517,12.675,12.675,0,0,1-3.009-1.276,11.538,11.538,0,0,1-1.362-3.028S84.555,48.59,83.76,47.9s-2.895-10.177,0-9.249,5.108,9.536,5.108,9.536a2.015,2.015,0,0,0,1.248.689c.737.059,2.214-.115,2.5.516S93.863,51.689,93.011,52.946Z",
    transform: "translate(13.713 6.431)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.285,47.447S91.911,48.5,91.9,49.768Z",
    transform: "translate(15.048 7.908)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.545,23.38a7.691,7.691,0,1,0-7.607-7.691A7.649,7.649,0,0,0,79.545,23.38Z",
    transform: "translate(11.99 1.333)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9,13.979a15.487,15.487,0,0,0,2.614-1c1.974-.7,4.157-.22,6.154.411a7.91,7.91,0,0,0,2.348.516,2.368,2.368,0,0,0,2.067-1.033,2.358,2.358,0,0,0-.014-2.157,6.063,6.063,0,0,0-1.389-1.734c-1.771-1.691-3.968-3.271-6.4-3.1a8.732,8.732,0,0,0-2.811.814,30.865,30.865,0,0,0-3.3,1.68c-.819.48-2.336,1.123-2.808,2C70.293,12.358,73.233,14.244,74.9,13.979Z",
    transform: "translate(11.856 0.978)",
    fill: "#3e373a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.085,11.449a2.368,2.368,0,0,1-2.067,1.033,7.912,7.912,0,0,1-2.35-.506c-2-.632-4.179-1.114-6.154-.411a14.721,14.721,0,0,1-2.614,1c-1.345.214-3.511-.971-3.746-2.477-.264,1.741,2.248,3.232,3.746,2.994a15.567,15.567,0,0,0,2.614-1c1.975-.7,4.157-.22,6.154.411a7.593,7.593,0,0,0,2.35.506,2.386,2.386,0,0,0,2.067-1.033,2.035,2.035,0,0,0,.238-1.258A1.872,1.872,0,0,1,88.085,11.449Z",
    transform: "translate(11.856 1.681)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.972,91.231s1.01,1.334-.467,3.35-2.692,3.717-2.2,4.974c0,0,2.227-3.743,4.039-3.8S140.962,93.481,138.972,91.231Z",
    transform: "translate(22.699 15.205)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.965,91.231a1.685,1.685,0,0,1,.205.418c1.767,2.1,2.711,4.062,1.01,4.11-1.584.046-3.482,2.91-3.937,3.631q.023.088.052.172s2.228-3.743,4.04-3.8S140.955,93.481,138.965,91.231Z",
    transform: "translate(22.707 15.205)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.213,92.732c0,.47-.053.851-.116.851s-.118-.381-.118-.851.065-.248.13-.248S140.213,92.262,140.213,92.732Z",
    transform: "translate(23.33 15.405)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.848,93.217c-.407.224-.763.36-.793.3s.274-.286.68-.517.247-.062.278,0S141.256,92.992,140.848,93.217Z",
    transform: "translate(23.342 15.481)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.325,91.231s-1.01,1.334.467,3.35,2.691,3.717,2.2,4.974c0,0-2.226-3.743-4.04-3.8S132.339,93.481,134.325,91.231Z",
    transform: "translate(22.01 15.205)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.325,91.231a1.648,1.648,0,0,0-.206.418c-1.768,2.1-2.71,4.062-1.009,4.11,1.582.046,3.482,2.91,3.936,3.631a1.28,1.28,0,0,1-.055.172s-2.225-3.743-4.039-3.8S132.339,93.481,134.325,91.231Z",
    transform: "translate(22.01 15.205)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.393,92.732c0,.47.05.851.115.851s.118-.381.118-.851-.067-.248-.13-.248S132.393,92.262,132.393,92.732Z",
    transform: "translate(22.066 15.405)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.875,93.217c.407.224.763.36.795.3s-.274-.286-.681-.517-.247-.062-.278,0S131.467,92.992,131.875,93.217Z",
    transform: "translate(21.938 15.481)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,107.588c5.83,0,10.557-.733,10.557-1.638s-4.727-1.637-10.557-1.637-10.558.733-10.558,1.637S131.965,107.588,137.8,107.588Z",
    transform: "translate(21.206 17.385)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,96.913l-.051.417-.071.589-.029.246-.071.589-.03.246-.07.587-.808,6.7c-.072.6-1.037,1.064-2.2,1.064h-4.2c-1.167,0-2.13-.467-2.2-1.064l-.809-6.7L131.881,99l-.029-.246-.071-.589-.032-.246-.069-.589-.051-.417c-.04-.344.482-.623,1.142-.623h8.585C142.016,96.289,142.539,96.574,142.5,96.913Z",
    transform: "translate(21.938 16.048)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,97.181l-.07.589H131.744l-.071-.589Z",
    transform: "translate(21.946 16.197)",
    fill: "#9d9cb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.324,97.9l-.069.589H131.83l-.071-.589Z",
    transform: "translate(21.96 16.316)",
    fill: "#9d9cb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.21,98.612l-.072.589H131.917l-.07-.589Z",
    transform: "translate(21.975 16.435)",
    fill: "#9d9cb5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.1336fb9eb4a9cacbdacb8c32dc96ba40.svg";
export { ForwardRef as ReactComponent };